import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { TQuestionData } from '@utils/chatbot/types'
import WidgetButton from '@components/Chatbot/buttons/WidgetButton'

type SuggestedQuestionProps = {
  question: TQuestionData
  isLoading: boolean
  onClick: (question: TQuestionData) => void
}

const StyledWidgetButton = styled(WidgetButton)`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small1: { bundledCSS: small1BodycopyCSS },
        },
      },
    },
  }) => css`
    ${small1BodycopyCSS};
  `}
`

const SuggestedQuestion: FunctionComponent<SuggestedQuestionProps> = ({
  question,
  onClick,
  isLoading,
}) => {
  return (
    <StyledWidgetButton
      onClick={() => onClick(question)}
      disabled={isLoading}
      iconSize={32}
    >
      {question.text}
    </StyledWidgetButton>
  )
}

export default SuggestedQuestion
